import { render, staticRenderFns } from "./situationAnalysisAnother.vue?vue&type=template&id=90065efc&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./situationAnalysisAnother.vue?vue&type=script&lang=js"
export * from "./situationAnalysisAnother.vue?vue&type=script&lang=js"
import style0 from "./situationAnalysisAnother.vue?vue&type=style&index=0&id=90065efc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90065efc",
  null
  
)

export default component.exports